import styled from 'styled-components';

export const StyledCol = styled.div<{
  col: number;
  gutterWidth: number;
  width: number | string;
  minColWidth: number | string;
}>`
  box-sizing: border-box;
  min-height: 1px;
  position: relative;
  padding-left: ${({ theme, gutterWidth }) => gutterWidth || theme.Form.formColGutter}px;
  padding-right: ${({ theme, gutterWidth }) => gutterWidth || theme.Form.formColGutter}px;
  flex-shrink: 0;
  max-width: ${({ width }) => (typeof width === 'string') ? width : 'none'};
  margin-left: 0%;
  right: auto;
  left: auto;
  flex-basis: ${({ minColWidth }) => minColWidth}px;
  flex-grow: 1;
  min-width: ${({ col, width }) => (typeof width === 'string') ? width : `${width || 100 / (12 / col)}%`};
`;
